/* eslint-disable */
import { useGameStore } from '@/store/game'
import { NPCOwnerManager } from '@/services/npcOwnerManager'

export class GameActions {
  static async performAction(actionType, actionData = null) {
    const gameStore = useGameStore()
      
    // Execute the action first
    await actionType.execute(actionData)
      
    // Handle both fixed numbers and functions for dayAdvance
    const daysToAdvance = typeof actionType.dayAdvance === 'function' 
      ? actionType.dayAdvance(actionData)
      : actionType.dayAdvance || 1
  
    // For longer day advances (like transit), process asynchronously with breaks
    if (daysToAdvance > 3) {
      await this.processLongDayAdvancement(daysToAdvance, gameStore)
    } else {
      for(let i = 0; i < daysToAdvance; i++) {
        NPCOwnerManager.processPostRaceActions(gameStore)
        gameStore.advanceDay()
      }
    }
  }
  
  static async processLongDayAdvancement(daysToAdvance, gameStore) {
    for(let i = 0; i < daysToAdvance; i++) {
      // Reduced background processing during transit to prevent hanging
      const isTransitDay = true
      
      // Lighter NPC processing during transit
      NPCOwnerManager.processPostRaceActions(gameStore, { skipHeavyOperations: isTransitDay })
      gameStore.advanceDay(isTransitDay)
      
      // Yield control to prevent UI blocking
      if (i % 2 === 0) {
        await new Promise(resolve => setTimeout(resolve, 10))
      }
    }
    
    // Single save operation after all days instead of saving each day
    gameStore.saveGame()
  }  
}

// Action type definitions
export const GameActionTypes = {
  RACE: {
    execute: async (raceData) => {
      // Race simulation is handled by race components
      return true
    },
    dayAdvance: 1
  },
  BREEDING: {
    execute: async (breedingData) => {
      // Breeding is handled by breeding components
      return true
    },
    dayAdvance: 1
  },
  PURCHASE: {
    execute: async (purchaseData) => {
      // Purchase is handled by auction/trade components
      return true
    },
    dayAdvance: 1
  },
  EXPEDITION: {
    execute: async (expeditionData) => {
      // Expedition is handled by expedition component
      return true
    },
    // Instead of fixed 1 day, we'll use the duration passed in the data
    dayAdvance: (data) => data.duration
  },
  TRANSIT: {
    execute: async (transitData) => {
      const gameStore = useGameStore()
      const { chocobo, route } = transitData
      
      // Mark chocobo as in transit to prevent race participation
      if (chocobo) {
        chocobo.inTransit = true
      }
      
      // Add weekly earnings
      const weeklyEarnings = route.dailyEarnings * 7
      gameStore.playerOwner.money += weeklyEarnings

      // Clear transit state after completion
      if (chocobo) {
        chocobo.inTransit = false
      }

      return true
    },
    dayAdvance: 7
  }

}
